var $c8c79cc04d9cfaf2$exports = {};
$c8c79cc04d9cfaf2$exports = {
    "valid": `\u{C720}\u{D6A8}`
};


export {$c8c79cc04d9cfaf2$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
